export default __webpack_public_path__ + "static/media/logo.eebe7406.png";